<template>
<div>

    <header id="header">
        <ul class="header-inner">
            <li id="menu-trigger" data-trigger="#sidebar"> 
                <div class="line-wrap">
                    <div class="line top"></div>
                    <div class="line center"></div>
                    <div class="line bottom"></div>
                </div>
            </li>

            <li class="logo">
                <a href="index.html">Tendiendo Puentes</a>
            </li>
            
            <li class="pull-right">
                <ul class="top-menu">
                    <li>
                        <a href="" v-scroll-to="'#section-home'" class="hidden-xs">SOBRE TENDIENDO PUENTES</a>
                    </li>
                    <li>
                        <a href="" v-scroll-to="'#section-roles'" class="hidden-xs">QUIERO PARTICIPAR</a>
                    </li>
                    <li>
                        <a href="" v-scroll-to="'#section-faq'" class="hidden-xs">PREGUNTAS FRECUENTES</a>
                    </li>
                    <li class="m-l-10 m-r-10">
                        <a href="" @click.prevent="$router.push('/comercios')" class="hidden-xs btn btn-sm bgm-orange">MAPA DE COMERCIOS</a>
                    </li>
                </ul>
            </li>
        </ul>
    </header>

    <section id="main">
        
        <aside id="sidebar">
            <div class="sidebar-inner c-overflow">
                
                <!-- <div class="profile-menu">
                    <a href="">
                        <div class="profile-pic"></div>
                        <div class="profile-info">{{ currentPerson.names }} {{ currentPerson.lastNames }}</div>
                    </a>                    
                </div> -->

                <ul class="main-menu" id="main-menu">
                    <li>
                        <a href="" v-scroll-to="'#section-home'"><i class="zmdi zmdi-device-hub"></i> Sobre Tendiendo Puentes</a>
                    </li>
                    <li>
                        <a href="" v-scroll-to="'#section-roles'"><i class="zmdi zmdi-accounts-outline"></i> Quiero participar</a>
                    </li>
                    <li>
                        <a href="" v-scroll-to="'#section-faq'"><i class="zmdi zmdi-help-outline"></i> Preguntas frecuentes</a>
                    </li>
                    <li>
                        <a href="" @click.prevent="$router.push('/comercios')"><i class="zmdi zmdi-map"></i> Mapa de comercios</a>
                    </li>
                </ul>

            </div>
        </aside>
        
        <!--/.sidebar-->

        <section>
            <div id="main-body">
                <landing-component></landing-component>
            </div>
        </section><!--/.content-->
        
    </section><!--/.main-->

</div>

</template>

<script>
    import landingComponent from './landing.vue';
    
    export default {
        data () {
            return {
            }
        },
        computed: {
        },
        components: {
            landingComponent
        },        
        created() {
        },
        methods: {

        }
    } 

</script>

<style lang="scss">

</style>
